// flow
import React, { useEffect, useState } from "react";
import 'react-piano/dist/styles.css';
// import "./drum.css";
import { Icon, IconClose } from '../../../base/icons';
import { connect } from "../../../base/redux/functions";
import { FEATURE_CUSTOM_REDUX } from "../../constant";

import keyboardShortcut from '../../../../../modules/keyboardshortcut/keyboardshortcut';
import { getBaseConfig } from "../../Utils.js";
import { useSelector } from "react-redux";
import { getLocalParticipant, PARTICIPANT_ROLE } from "../../../base/participants";
import { getLJsonStorage } from "../../welcome-dashboard/Utils";
import { i18next } from "../../../base/i18n/index";


const minimizeTool = () => {
    if (document.getElementById('drum-container').matches('.drum-tool-minimize')) {
        document.getElementById('drum-container').classList.remove('drum-tool-minimize');
    } else {
        document.getElementById('drum-container').classList.add('drum-tool-minimize');
    }
}

const DrumSet = (props) => {
    const { socket, Sessions, closeTool } = props;
    const { openByUser, SessionId } = Sessions;

    const [isDisable, setIsDisable] = useState(false);

    useEffect(() => {
        const { decodedData, secondModerator } = props;
        console.log('sessionId ==>',openByUser)

        if (SessionId === openByUser) {
            setIsDisable(false);
        }

        if (!decodedData || secondModerator || decodedData?.gm) {
            setIsDisable(false);
        } else if (decodedData.student) {
            setIsDisable(true);
        }

        return () => {
            socket.off('played_note_return');
        };
    }, [openByUser]);


    useEffect(() => {

        keyboardShortcut.enable(false);
        return () => {
            keyboardShortcut.enable(true);

        }
    }, [])
    let localParticipant = useSelector(getLocalParticipant);
    let isModerator = Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR);
    const { room_name } = props;
    let moderatorVal = '';
    if (isModerator == true) {
        moderatorVal = isModerator;
    } else {
        moderatorVal = "";
    }
    let src = getBaseConfig("drumSetUrl") + "?room_name=" + room_name + "&moderator=" + moderatorVal + "&allowPlay=true&color=" + getBaseConfig("themePrimaryColor") + "&sessionId=" + SessionId;
    const isGuestAccount = getLJsonStorage("auth", "guest_id");

    let currentLanguage: string = i18next.language;

    if (currentLanguage) {
        src = src + "&_lang=" + currentLanguage
    }

    return (

        <div className='tool-layer'>
            <div className="drum-container" id="drum-container" data-type={isDisable ? 1 : 0}>
                <div className="drum-action-icons">
                    {(isDisable || isGuestAccount) ? '' :
                        <div
                            id="down-arrow-icon"
                            className='minimize-side-bar'
                            onClick={minimizeTool}>
                            <i className="fa fa-angle-down"></i>
                        </div>
                    }
                    {(isDisable || isGuestAccount) ? '' :
                        <div
                            className='close-side-bar'
                            id="drum-close-icon-wrapper"
                            onClick={closeTool}>
                            <Icon containerId="drum-set-close-icon" src={IconClose} />
                        </div>
                    }
                </div>
                <iframe id="drum-set-iframe" src={src} style={{ height: "inherit", width: "100%", border: "none" }}></iframe>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        room_name: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData
    }
}

export default connect(mapStateToProps)(DrumSet);